import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;


//获取会员卡列表
export const memberCardList = params => {
    return axios.get(`${base}/api/MembershipCard/GetMembershipCardList`, { params: params });
};

//新增会员卡
export const addMemberCard = params => {
    return axios.post(`${base}/api/MembershipCard/PostAddMembershipCard`, params);
}
//删除会员卡
export const deleteMemberCard = params => {
    return axios.delete(`${base}/api/MembershipCard/DeleteMembershipCard`, { params: params });
}
//会员卡详情
export const memberCardDetail = params => {
    return axios.get(`${base}/api/MembershipCard/GetMembershipCardDetail`, { params: params });
}
//修改会员卡
export const updateMemberCard = params => {
    return axios.post(`${base}/api/MembershipCard/PostUpdateMembershipCard`, params);
}